export default __webpack_public_path__ + "static/uniswap-b03e71a9c2d1591bd3b5a56dd0bb8264.svg";